<template>
  <div class="notifications-wrapper">
    <div class="notifications-header">
      <h3 class="n-header">Notifications</h3>
      <span v-if="newCount" class="new-count">{{newCount}} New</span>

      <md-button class="md-icon-button fb-close" @click="closeWrapper">
        <md-icon>close</md-icon>
      </md-button>
    </div>

    <div v-if="records == 0" class="notifications">
      <div class="default-text">Your notifications<br>will show up here!</div>
    </div>
    <div v-else class="notifications">
      <ul v-if="(paginatedShown || $mq == 'large' || $mq == 'xlarge')" class="notifications-list">
        <li class="md-list-item n-item" :key="item.id" v-for="item in paginatedData" v-bind:class="{'is-new': item.isNew}" v-bind:data-id="item.id">
          <div v-html="item.body" class="md-list-item-text"></div>
          <span class="md-list-item-date">{{ item.date }}</span>
          <a v-if="item.linkText" :aria-label="item.linkText" @click="viewNotification(item)" class="md-list-item-link">{{item.linkText}}<md-icon>arrow_right_alt</md-icon></a>
        </li>
      </ul>
      <ul v-else class="notifications-list">
        <li v-for="(number, index) in (notifications.length > maxInitNotifiactions ? maxInitNotifiactions : notifications.length)" :key="index" class="md-list-item n-item"
            v-bind:class="{'is-new': notifications[index].isNew}" v-bind:data-id="notifications[index].id">
          <div v-html="notifications[index].body" class="md-list-item-text"></div>
          <span class="md-list-item-date">{{ notifications[index].date }}</span>
          <a v-if="notifications[index].linkText" :aria-label="notifications[index].linkText" @click="viewNotification(notifications[index])" class="md-list-item-link">{{notifications[index].linkText}}</a>
        </li>
      </ul>

      <div v-if="notifications.length > maxInitNotifiactions" class="notifications-footer">
          <div v-if="(paginatedShown || $mq == 'large' || $mq == 'xlarge')" class="pagination">
            <pagination v-model="currentPage" :records="records" :per-page="perPage"
                        :options="{chunk:3, chunksNavigation:true, edgeNavigation:true}" @paginate="pagerAction"></pagination>
          </div>
          <a v-else class="notifications-all" @click="showPaginated">See all recent notifications</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Notifications",
  data() {
    return {
      maxInitNotifiactions: 4,
      notifications: window.drupalSettings.notifications.items,
      records: window.drupalSettings.notifications.items.length,
      newCount: window.drupalSettings.notifications.newCount,
      currentPage: 1,
      maxPages: Math.max(Math.ceil(window.drupalSettings.notifications.items.length / this.perPage), 1),
      paginatedShown: 0,
    };
  },
  props: {
    perPage: {
      type: Number,
      required: false,
      'default': 5,
    },
  },
  methods: {
    showPaginated() {
      this.paginatedShown = 1;
    },
    showRecent() {
      this.paginatedShown = 0;
      this.currentPage = 1;
    },
    closeWrapper() {
      this.showRecent();
      this.$emit('close');
    },
    pagerAction(page) {
      if(page) {
        this.currentPage = page;
      }
    },
    viewNotification(item) {
      if (item.type == 'custom_notification') {
        this.getToken().then((token) => {
          let fetch_headers = new Headers();
          fetch_headers.append("Content-Type", "application/json");
          fetch_headers.append("X-CSRF-Token", token);
          fetch('/api/catch-notifications/mark-read/' + window.drupalSettings.user.uid + '/' + item.id, {
            credentials: "include",
            method: "GET",
            headers: fetch_headers,
          })
            .then((response) => {
              return response.json();
            })
            .then((data) => {
              if (data.status) {
                window.location.reload();
              } else if (!data.status && data.message) {
                console.log(data.message);
              }
            });
        });
      }
      else {
        window.open(item.linkUrl, item.target);
      }
    },
    getToken() {
      return fetch("/session/token?t=" + Date.now(), {
        credentials: "include",
      })
        .then((response) => {
          return response.text();
        })
        .then((text) => {
          return text;
        });
    },
  },
  computed: {
    paginatedData() {
      let start = (this.currentPage - 1) * this.perPage,
              end = start + this.perPage;
      return this.notifications.slice(start, end);
    },
  },
  watch: {
    paginatedShown(newVal){
      this.$emit('isNotificationList', newVal);
    }
  }
};
</script>
